import { render } from "./GenderPage.vue?vue&type=template&id=a6337966&scoped=true"
import script from "./GenderPage.vue?vue&type=script&lang=js"
export * from "./GenderPage.vue?vue&type=script&lang=js"

import "./GenderPage.vue?vue&type=style&index=0&id=a6337966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6337966"]])

export default __exports__